import {
  zodAustralianOrInternationalPhoneNumber,
  zodPasswordSchema,
} from '@idu-nightlife/nightlife-utils';
import type { FunctionComponent, SVGProps } from 'react';
import { z } from 'zod';

/** SVG logo component an app passes into the shared invite surfaces. */
export type InviteLogo = FunctionComponent<SVGProps<SVGSVGElement>>;

export const inviteAcceptSchema = z
  .object({
    name: z.string().trim().min(1, { message: 'Fullname is required' }),
    // Optional means optional: see the note in trackd's signup-page. `().optional()` accepts
    // `undefined` but not the `''` this form defaults to, which made a phone number effectively
    // mandatory to accept an invitation.
    phone: zodAustralianOrInternationalPhoneNumber(false),
    password: zodPasswordSchema,
    confirmPassword: zodPasswordSchema,
  })
  .superRefine(({ password, confirmPassword }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: 'custom',
        message: 'The passwords do not match',
        path: ['confirmPassword'],
      });
    }
  });

export type InviteAcceptFormData = z.infer<typeof inviteAcceptSchema>;
